import { render, staticRenderFns } from "./info_evento_vih.vue?vue&type=template&id=34fda808"
import script from "./info_evento_vih.vue?vue&type=script&lang=js"
export * from "./info_evento_vih.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports